import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";
import {  POLICY_UNDERWRITING } from "../Business.constants";



const PolicyUnderwriting = Loadable(
  lazy(() =>
	import("./PolicyUnderwriting").then(
	  ({ PolicyUnderwriting }) => ({
		default: PolicyUnderwriting,
	  })
	)
  )
);
export const PolicyUnderwritingRoutes = [
  
 {
             path: `${POLICY_UNDERWRITING}/:customerPolicyId`,
             exact: true,
             element: (
               <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                 <PolicyUnderwriting />
               </AuthorizedRoute>
             ),
           },
];
